// removed by extract-text-webpack-plugin
module.exports = {"contentDetailContainer":"_3FEaJJoViaAmg0phVskXJt","contentDetail":"_35PmBSvAa6TFHlOqy5NC0f","chtContentDetail":"_32xELc0I4x5s5ZfWnmilK9","contentInfos":"_1O1fSS-vnlRfd0Vx-jgZ-e","engContentInfos":"_1bRcPgXVTZDFTm4lpNkUtV","infoKey":"_2tyeqOtGao2S4mU-H5DMMb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-detail/ContentDetail.css
// module id = 376
// module chunks = 0